module.exports = __webpack_public_path__ + "img/41.0abdbfa3.png";